import {Enum} from "~/enums/index";

export default new Enum({
    SCHEDULED: "SCHEDULED",
    RUNNING: "RUNNING",
    FINISHED: "FINISHED",
    ERROR: "ERROR",
});
